export const appNam = 'AB tools';
export const DATE_FORMAT_MMDDYYYY = 'MM/DD/YYYY';
export const DATE_FORMAT_MMDDYYYYHHMMA = 'MM/DD/YYYY hh:mm A';
export const NO_MATCHING_RECORDS_FOUND = 'No matching records found.';

export const WorkQueueTabConstant = {
  INVOLVED_PARTIES: 'involved-parties',
  AGREEMENT: 'agreement',
  STATUS_HISTORY: 'status-history',
  COMMENTS: 'comments',
  Scoring: 'scoring',
};

export const NETWORK_ERROR = {
  error: 'Network Error',
  message: `Application seems to be not responding. Please try again after 15 minutes. 
    If the issue still persists, raise a Service Now Ticket`,
  code: 502,
};

export const GENERIC_ERROR = `Something went wrong. Please try again after 15 minutes. 
If the issue still persists, raise a Service Now Ticket`;

export const WORKLIST_ID_CHAR_VALIDATION_ERROR = 'WorkList ID should be alphanumeric and 7 characters';

export const PEGA_URL = 'https://jdf-pega.deere.com/prweb/sso1';
